import { render, staticRenderFns } from "./pc-big-star.vue?vue&type=template&id=17768fa8"
import script from "./pc-big-star.vue?vue&type=script&lang=js"
export * from "./pc-big-star.vue?vue&type=script&lang=js"
import style0 from "./pc-big-star.vue?vue&type=style&index=0&id=17768fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports